const STORAGE_KEY = 'aivia.auth.returnTo';
const FALLBACK_PATH = '/threads';

const currentLocation = (): string => {
  if (typeof window === 'undefined' || !window.location) {
    return FALLBACK_PATH;
  }
  const { pathname, search, hash } = window.location;
  const value = `${pathname}${search}${hash}`;
  return value && value.length > 0 ? value : FALLBACK_PATH;
};

export const rememberReturnPath = () => {
  if (typeof window === 'undefined') {
    return;
  }
  window.sessionStorage.setItem(STORAGE_KEY, currentLocation());
};

export const consumeReturnPath = (fallback = FALLBACK_PATH): string => {
  if (typeof window === 'undefined') {
    return fallback;
  }
  const value = window.sessionStorage.getItem(STORAGE_KEY);
  if (typeof value === 'string' && value.length > 0) {
    window.sessionStorage.removeItem(STORAGE_KEY);
    return value;
  }
  return fallback;
};

export const peekReturnPath = (fallback = FALLBACK_PATH): string => {
  if (typeof window === 'undefined') {
    return fallback;
  }
  const value = window.sessionStorage.getItem(STORAGE_KEY);
  return typeof value === 'string' && value.length > 0 ? value : fallback;
};

export const peekStoredReturnPath = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  const value = window.sessionStorage.getItem(STORAGE_KEY);
  return typeof value === 'string' && value.length > 0 ? value : null;
};

export const clearReturnPath = () => {
  if (typeof window === 'undefined') {
    return;
  }
  window.sessionStorage.removeItem(STORAGE_KEY);
};
